import GCalList from "./gcal/GCalList.tsx";
import {useAccount} from "../Accounts.tsx";
import {useBrandingTitleSuffix} from "../../../../../appfw/ui/branding/BrandingControl.tsx";

export default function ImportersPage() {

    const account = useAccount()

    useBrandingTitleSuffix("Importer")

    return (
        <GCalList accountId={account.id}/>
    )
}
